import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { useAgendamentoPorId } from "../../../hooks/queries/agendamento/useAgendamentoPorId/useAgendamentoPorId";
import { useVeiculoPorId } from "../../../hooks/queries/veiculo/useVeiculoPorId/useVeiculoPorId";
import { useVincularAgendamentoVeiculo } from "../../../hooks/queries/agendamento/useVincularAgendamentoVeiculo/useVincularAgendamentoVeiculo";
import { Tracking } from "../../../services/Tracking";
import {
  getTipoVeiculoLabel,
  TipoVeiculoEnumType,
} from "../../../enums/tipoVeiculo";

export const useVehicleV2 = () => {
  const navigate = useNavigate();
  const { uuidAgendamento } = useParams();
  const [searchParams] = useSearchParams();
  const uuidVeiculo = searchParams.get("uuidVeiculo") ?? "";
  const stepIndicator = useAgendamentoStepIndicator();

  const { data: agendamento } = useAgendamentoPorId(uuidAgendamento ?? "");
  const { data: veiculo } = useVeiculoPorId(uuidVeiculo);
  const { mutate: vincularVeiculo } = useVincularAgendamentoVeiculo();

  function handleConfirmar() {
    vincularVeiculo(
      { uuidAgendamento, uuidVeiculo },
      {
        onSuccess: ({ data }) => {
          const revistoria = agendamento?.revistoria;
          const destinoPagamento = `/agendamento/${uuidAgendamento}/pagamento`;
          const destinoRevistoria = `/agendamento/${uuidAgendamento}/confirmar-horario`;

          navigate(revistoria ? destinoRevistoria : destinoPagamento);
        },
        onError: ({
          response: {
            data: { mensagem },
          },
        }: any) => {
          Tracking.error(
            "mapa:agendamento/servicos/veiculo:vincular-veiculo-falhou",
            { mensagem },
          );
        },
      },
    );
  }

  return {
    stepIndicator,
    veiculo,
    podeConfirmar: !!veiculo && !!agendamento,
    tipoVeiculoLabel: veiculo
      ? getTipoVeiculoLabel(veiculo.tipo as TipoVeiculoEnumType)
      : "",
    handleConfirmar,
  };
};
